<template>
    <div>
        <div id="loading" v-if="page !== 'home'">
            <div class="fg-loader-center" style="text-align: center;">
                <div class="fg-loader"></div>
                <h1 class="fg-loader-text" style="font-family: Arial; font-size: 20px; font-weight: normal; text-align: center; width:350px;margin-left:-130px; margin-top: 30px;">Loading...</h1>
            </div>
        </div>
        <a href="">
            <vue-load-image class="logo logo_desktop">
                <img slot="image" :src="`${baseUrl}assets/images/stepslogo.png`" alt="theSTEPs.org"/>
                <img slot="preloader" class="preloader" :src="`${baseUrl}/assets/img/loader.gif`" title="Image Loading...">
            </vue-load-image>
        </a>
    </div>
</template>
<script>
  import VueLoadImage from 'vue-load-image';

  export default {
    components: {
      'vue-load-image': VueLoadImage,
    },
    props: {
      page: String,
    },
  };
</script>
